import React, { useMemo} from 'react';
import './CustomChargerInfoCard.css';
import { Icon, IconWithTooltip } from '../../../globalUtils/globalIcons';
import { CustomTooltipWithLabel, formatRelativeTimeForTable, useAppDispatch } from '../../../globalUtils/globalExports';
import { startCase } from 'lodash';
import { setChargerIdsForRedirection } from '../../rmsReduxStore/acNocDashboardRedux/acNocDashboardCreator';

interface ICustomChargerInfoCardProp {
  charger: IChargerDetails;
  handleMarkerClicked:(item:IChargerDetails)=>void;
  isLatestAlarm?:boolean
}
const AcCustomChargerInfoCard: React.FC<ICustomChargerInfoCardProp> = (props) => {
    const{charger,handleMarkerClicked,isLatestAlarm} = props;
    const dispatch = useAppDispatch();
    function getFormattedTimeFromDate(date: Date) {
        const hr = date?.getHours();
        const min = String(date?.getMinutes()).padStart(2, '0');
        const sec = String(date?.getSeconds()).padStart(2, '0');
        const meridian = hr > 11 ? 'PM' : 'AM';
        const hour = String(hr % 12 || 12).padStart(2, '0');
        return `${hour}:${min}:${sec} ${meridian?.toUpperCase()}`
    }

    const connectorChargingSessionStatus = useMemo(() => {
        const chargingSessionsStatus = [
            { key: 'C1', value: charger?.activeChargingSession1 },
            { key: 'C2', value: charger?.activeChargingSession2 },
            { key: 'C3', value: charger?.activeChargingSession3 }
        ];
        return chargingSessionsStatus?.filter(item => item.value !== null)
    }, [charger])

    const handleChargerClicked = (chargerSerialId, chargerId) => {
        dispatch(setChargerIdsForRedirection([chargerId]))
        window.open(`/ac/charger?chargerId=${chargerSerialId}&redirectedFrom=nocDashboard`, '_blank');
    }

    const critical = charger?.alarms?.critical;
    const minor = charger?.alarms?.minor;
    const major = charger?.alarms?.major;
    const showAlarmContainer = (critical ?? 0) > 0 || (minor ?? 0) > 0 ||  (major ?? 0) > 0 ;

    return (
        <div className='noc-dashboard-custom-charger-info-card'>
            <div className='noc-dashboard-custom-charger-info-card-charger-info'>
                <div className='noc-dashboard-custom-charger-info-card-charger-info-left'>
                    <div className='noc-dashboad-custom-charger-icon'>
                        <Icon iconClassName='noc-dashboard-cluster-marker-icon' />
                    </div>
                    <div className='noc-dashboard-custom-charger-serial-id'
                        onClick={() => { handleChargerClicked(charger?.name, charger?.id) }}
                    >
                        <CustomTooltipWithLabel label={charger?.name ?? ''} labelId={'charger-name-' + charger?.id} />
                    </div>
                </div>
                <div className='noc-dashbaord-custom-charger-ocpp-id'>
                    <div className='noc-dashboard-custom-charger-ocpp-id-label'>OCPP ID:</div>
                    <div className='noc-dashboard-custom-charger-ocpp-id-value'>
                        <CustomTooltipWithLabel label={charger?.ocppId ?? ''} labelId={charger?.id} />
                    </div>
             { !isLatestAlarm &&
             <div className='noc-dashboard-custom-info-charger-card-close-icon-container'>
              <div className="noc-dashboard-charger-close-btn" onClick={() => (handleMarkerClicked(charger))}> ×</div>
                </div>}
                </div>
            </div>
            <div className='noc-dashboard-custom-charger-info-card-cs-customer-info'>
                <div className='noc-dashboard-custom-charger-info-card-cs-info'>
                    <CustomTooltipWithLabel label={charger?.chargingStation ?? ''} labelId={charger?.id} />
                </div>
                <div className='noc-dashboard-custom-charger-info-card-cs-customer-info-separator'></div>
                <div className='noc-dashboard-custom-charger-info-card-customer-info-container'>
                    <Icon iconClassName='noc-dashboard-customer-icon' />
                    <div className='noc-dashboard-custom-charger-info-card-customer-info'>
                        <CustomTooltipWithLabel label={charger?.customer ?? ''} labelId={charger?.id} />
                    </div>
                </div>
            </div>

            <div className='noc-dashboard-custom-charger-info-card-charger-status-info'>
                <div className={charger?.status?.toLowerCase() === 'online' ? 'noc-dashboard-custom-charger-info-card-connectivity-status-online' : 'noc-dashboard-custom-charger-info-card-connectivity-status-offline'}>
                    <div className='noc-dashboard-custom-charger-info-card-connectivity-status-icon-container'>
                        <Icon iconClassName={charger?.status?.toLowerCase() === 'online' ? 'noc-dashboard-charger-online-icon' : 'noc-dashboard-charger-offline-icon'} />
                    </div>
                    <div className='noc-dashboard-custom-charger-info-card-connectivity-status-text'>
                        {startCase(charger?.status)}
                    </div>
                </div>
                <div className='noc-dashboard-custom-charger-info-card-product-type'>
                    {charger?.productType}
                </div>
                <div className={`noc-dashboard-custom-charger-info-card-rms-connectivity ${charger?.rmsStatus === 'Enable' ? 'noc-dashboard-custom-charger-info-card-rms-connected' : 'noc-dashboard-custom-charger-info-card-rms-disconnected'}`}>
                    <div className='noc-dashboard-custom-charger-info-card-rms-connectivity-label'>RMS</div>
                    <div className='noc-dashboard-custom-charger-info-card-rms-connectivity-status'>
                        <Icon iconClassName={charger?.rmsStatus === 'Enable' ? 'noc-dashboard-right-panel-charger-connectivity-enable-icon' : 'noc-dashboard-right-panel-charger-connectivity-disable-icon'} />
                    </div>
                </div>
                <div className={`noc-dashboard-custom-charger-info-card-cms-connectivity ${charger?.cmsConnectivity === 'OK' ? 'noc-dashboard-custom-charger-info-card-cms-connected' : 'noc-dashboard-custom-charger-info-card-cms-disconnected'}`}>
                    <div className='noc-dashboard-custom-charger-info-card-cms-connectivity-label'>CMS</div>
                    <div className='noc-dashboard-custom-charger-info-card-cms-connectivity-status'>
                        <Icon iconClassName={charger?.cmsConnectivity === 'OK' ? 'noc-dashboard-right-panel-charger-connectivity-enable-icon' : 'noc-dashboard-right-panel-charger-connectivity-disable-icon'} />
                    </div>
                </div>
            </div>

            <div className='noc-dashboard-custom-charger-info-card-charger-alarm-info'>
                <div className='noc-dashboard-custom-charger-info-card-charger-alarms-status'>
                    <div className='noc-dashboard-custom-charger-info-card-charger-alarms-status-critical'>
                        <div className='noc-dashboard-custom-charger-info-card-charger-alarms-status-critical-alarm-icon-container'>
                            <Icon iconClassName='noc-dashboard-custom-charger-info-card-critical-alarm-icon' />
                        </div>
                        <div className='noc-dashboard-custom-charger-info-card-charger-alarms-status-alarm-count'>
                            {charger?.alarms?.critical ?? 0}
                        </div>
                    </div>
                    <div className='noc-dashboard-custom-charger-info-card-charger-alarms-status-major'>
                        <div className='noc-dashboard-custom-charger-info-card-charger-alarms-status-major-alarm-icon-container'>
                            <Icon iconClassName='noc-dashboard-custom-charger-info-card-major-alarm-icon' />
                        </div>
                        <div className='noc-dashboard-custom-charger-info-card-charger-alarms-status-alarm-count'>
                           {charger?.alarms?.major ?? 0}
                        </div>
                    </div>
                    <div className='noc-dashboard-custom-charger-info-card-charger-alarms-status-minor'>
                        <div className='noc-dashboard-custom-charger-info-card-charger-alarms-status-minor-alarm-icon-container'>
                            <Icon iconClassName='noc-dashboard-custom-charger-info-card-minor-alarm-icon' />
                        </div>
                        <div className='noc-dashboard-custom-charger-info-card-charger-alarms-status-alarm-count'>
                            {charger?.alarms?.minor ?? 0}
                        </div>
                    </div>
                </div>
                <div className='noc-dashboard-custom-charger-info-card-charger-latest-alarm-text-container'>
                    <div className='noc-dashboard-custom-charger-info-card-charger-latest-alarm-text-icon-container'>
                        <Icon iconClassName='noc-dashboard-custom-charger-info-card-latest-alarm-icon' />
                    </div>
                    <div className='noc-dashboard-custom-charger-info-card-charger-latest-alarm-text'>
                            <CustomTooltipWithLabel label={showAlarmContainer?charger?.lastAlarmText ?? '' : 'NA'} labelId={'latest-alarm-text' + charger?.lastAlarmText} />
                    </div>
                    <div className='noc-dashboard-custom-charger-info-card-charger-latest-alarm-set-time'>
                        <CustomTooltipWithLabel label={charger?.alarmSetAt ? getFormattedTimeFromDate(new Date(charger?.alarmSetAt?.replace('Z', ''))) : '-'} labelId={'latest-alarm-set-time' + charger?.lastAlarmText} />
                    </div>
                </div>
            </div>


            <div className='noc-dashboard-charger-info-card-footer'>
                <div className='noc-dashboard-charger-info-card-footer-left'>
                    <div className='noc-dashboard-custom-charger-info-card-last-ping-time-container'>
                        <span className='noc-dashboard-custom-charger-info-card-last-ping-time-label'>Last Ping:</span>
                        <span className='noc-dashboard-custom-charger-info-card-last-ping-time'>
                            {formatRelativeTimeForTable((charger?.lastPingTime ? new Date(charger?.lastPingTime) : new Date()))}
                        </span>
                    </div>
                </div>
                <div className='noc-dashboard-custom-charger-info-card-charging-status-indicators-container'>
                    {
                        connectorChargingSessionStatus?.map(connectorStatus => {
                            return (
                                <div key={'noc-dashboard-connector-session-statuts-' + connectorStatus?.key} className='noc-dashboard-custom-charger-info-card-charging-status-indicator'>
                                    <span className='noc-dashboard-custom-charger-info-card-charging-status-indicator-label'>{connectorStatus?.key}</span>
                                    <span className='noc-dashboard-custom-charger-info-card-charging-status-indicator-icon'>{connectorStatus?.value ? <IconWithTooltip iconClassName='rms__icon custom__noc__map__charging-status-active-btn-icon' toolTipText='Active Charging Session' /> : <IconWithTooltip iconClassName='rms__icon custom__noc__map__charging-status-inactive-btn-icon' toolTipText='Idle Charger' />}</span>
                                </div>
                            )
                        })
                    }
                </div>
            </div>

            <div className='noc-dashboard-charger-info-card-pointer'>
                <div className='noc-dashboard-charger-info-card-pointer-internal'></div>
            </div>
        </div>
    )
}


export default AcCustomChargerInfoCard;
